export const codesImpôt = {
	DSAP: {
		1: 'DSAP',
		2: 'DSBP',
	},
	DSAQ: {
		1: 'DSAQ',
		2: 'DSBQ',
	},
	DSCS: {
		1: 'DSCS',
		2: 'DSDS',
	},
	DSAS: {
		1: 'DSAS',
		2: 'DSBS',
	},
	DSAG: {
		1: 'DSAG',
		2: 'DSBG',
	},
	DSCP: {
		1: 'DSCP',
		2: 'DSDP',
	},
	DSFA: {
		1: 'DSFA',
		2: 'DSFB',
	},
	DSCO: {
		1: 'DSCO',
		2: 'DSDO',
	},
	DSCN: {
		1: 'DSCN',
		2: 'DSDN',
	},
	DSCA: {
		1: 'DSCA',
		2: 'DSCB',
	},
	DSGA: {
		1: 'DSGA',
		2: 'DSGB',
	},
	DSHA: {
		1: 'DSHA',
		2: 'DSHB',
	},
	DSCR: {
		1: 'DSCR',
		2: 'DSDR',
	},
	DSCQ: {
		1: 'DSCQ',
		2: 'DSDQ',
	},
	DSAT: {
		1: 'DSAT',
		2: 'DSBT',
	},
	DSEA: {
		1: 'DSEA',
		2: 'DSEB',
	},
	DSAR: {
		1: 'DSAR',
		2: 'DSBR',
	},
	DSCM: {
		1: 'DSCM',
		2: 'DSDM',
	},
	DSAV: {
		1: 'DSAV',
		2: 'DSBV',
	},
	DSAW: {
		1: 'DSAW',
		2: 'DSBW',
	},
	DSAX: {
		1: 'DSAX',
		2: 'DSBX',
	},
	DSAY: {
		1: 'DSAY',
		2: 'DSBY',
	},
	DSAZ: {
		1: 'DSAZ',
		2: 'DSBZ',
	},
}
